import { createAsyncThunk } from '@reduxjs/toolkit';
import { discussionForumGradingApi } from '~/apis/discussion-forum-grading';
import {
  CREATE_DISCUSSION_FORUM_GRADING,
  DELETE_DISCUSSION_FORUM_GRADING,
  GET_LIST_DISCUSSION_FORUM_GRADING,
  UPDATE_DISCUSSION_FORUM_GRADING,
} from '~/utils/constants/actionType';
import {
  IBodyCreateDiscussionForumGrade,
  IBodyUpdateDiscussionForumGrade,
  IQueryGetDiscussionForumGrading,
} from '~/utils/interface/discussion';

export const getListDiscussionForumGrading = createAsyncThunk(
  GET_LIST_DISCUSSION_FORUM_GRADING,
  async (payload: IQueryGetDiscussionForumGrading, { rejectWithValue }) => {
    try {
      const res = await discussionForumGradingApi.getListDiscussionForumGrading(payload);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createDiscussionForumGrading = createAsyncThunk(
  CREATE_DISCUSSION_FORUM_GRADING,
  async (payload: IBodyCreateDiscussionForumGrade, { rejectWithValue }) => {
    try {
      const res = await discussionForumGradingApi.createDiscussionForumGrading(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateDiscussionForumGrading = createAsyncThunk(
  UPDATE_DISCUSSION_FORUM_GRADING,
  async (payload: { gradingId: string; body: IBodyUpdateDiscussionForumGrade }, { rejectWithValue }) => {
    try {
      const res = await discussionForumGradingApi.updateDiscussionForumGrading(payload.gradingId, payload.body);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteDiscussionForumGrading = createAsyncThunk(
  DELETE_DISCUSSION_FORUM_GRADING,
  async (gradingId: string, { rejectWithValue }) => {
    try {
      const res = await discussionForumGradingApi.deleteDiscussionForumGrading(gradingId);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
